import { use } from 'react';
import { EnvironmentContext } from '../../providers/EnvironmentProvider';

export const useEnvironment = () => use(EnvironmentContext);
